import { useEffect, useRef, useState } from 'react';

// Tracks a trigger's rendered width, so a menu can match it. It measures again on resize, because
// the trigger is fluid.
export function useMeasuredWidth() {
    const ref = useRef<HTMLButtonElement>(null);
    const [width, setWidth] = useState<number>();

    useEffect(() => {
        const element = ref.current;
        if (!element) return undefined;

        const observer = new ResizeObserver(() => setWidth(element.getBoundingClientRect().width));
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return [ref, width] as const;
}
